export default __webpack_public_path__ + "static/media/TotalEnergies_Logo_RGB.be8b87a7.png";